module.exports = __webpack_public_path__ + "img/praca-matriz.889ce57b.jpg";